import script from "./componentStatistic.vue?vue&type=script&lang=js"
export * from "./componentStatistic.vue?vue&type=script&lang=js"

import "./componentStatistic.vue?vue&type=style&index=0&id=b9b49490&lang=css"

const __exports__ = script;

export default __exports__